import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IEntityBase} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchGradeLevelsThunk: any = createAsyncThunk<IEntityBase[]>(
  `${prefix} fetchGradeLevels`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getAvailableGradeLevels();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch grade levels. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
